import { Info } from "lucide-react";
import { PreviewCard } from "@/components/PreviewCard";
import { Reveal } from "@/components/Reveal";
import { STORE } from "@/constants/testIds";

const PAGES = [
  {
    screen: "learn",
    title: "Learning path (Sample)",
    testId: "preview-mockup-learn",
    caption: "Short Illinois-first lessons, key terms, source links, and live question checkpoints.",
  },
  {
    screen: "dashboard",
    title: "Study dashboard (Sample)",
    testId: STORE.mockupCover,
    caption: "A focused dashboard for readiness, weak areas, and the next study session.",
  },
  {
    screen: "question",
    title: "Illinois state question (Sample)",
    testId: STORE.mockupToc,
    caption: "Scenario-style Illinois state-section questions with clear multiple-choice options.",
  },
  {
    screen: "explanation",
    title: "Answer explanation (Sample)",
    testId: STORE.mockupQuestion,
    caption: "Plain-English rationale, source references, and Question Coach prompts after you answer.",
  },
  {
    screen: "score",
    title: "Score tracker (Sample)",
    testId: STORE.mockupExplanation,
    caption: "Track accuracy, coverage, missed questions, and readiness over time.",
  },
  {
    screen: "word-bank",
    title: "Word Bank (Sample)",
    testId: STORE.mockupScore,
    caption: "Review vocabulary and concepts with flashcard-style study tools.",
  },
  {
    screen: "sprint",
    title: "Timed Review Sprint (Sample)",
    testId: "preview-mockup-miniexam",
    caption: "Build exam-day pacing and stamina with short, timed review sprints.",
  },
];

export const PreviewGallery = () => (
  <>
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      {PAGES.map((p) => (
        <Reveal key={p.title}>
          <PreviewCard {...p} />
        </Reveal>
      ))}
    </div>

    <div className="mt-10 flex items-start gap-3 rounded-2xl border border-[color:rgba(10,27,51,0.12)] bg-white p-5 text-sm leading-6 text-[color:rgba(11,18,32,0.7)]">
      <Info className="mt-0.5 h-5 w-5 shrink-0 text-[#B7791F]" />
      <p>
        Sample screens are for preview only. All practice questions are original
        and based on public exam-topic guidance and Illinois real estate
        concepts. Illinois Broker Prep is not affiliated with PSI, IDFPR, the
        State of Illinois, or any real estate commission.
      </p>
    </div>
  </>
);

export default PreviewGallery;
